module.exports = __webpack_public_path__ + "assets/icon-gate-fieldGate.7fa55912.svg";